var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReportsSumariesView } from "./iu/reportsSumaries.view";
import { useApiPostExecuteReports } from "../../fnx/reports/postExecuteReports";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCurrentMonth, getCurrentSemester, getPreviousMonth, getQuarterDates, } from "../../services/getDates";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../fnx/showError";
import { executeReportsClearData, reportsClearData, } from "../../store/reports/actions";
import { useDispatch } from "react-redux";
import { formattedDateYYMMDD, newFormattedDate } from "../../utils/date";
import { useApiPostReports } from "../../fnx/reports/postReports";
import { useDownloadReportExcel } from "../../fnx/reports/reportExportExcel";
export var ReportsSummaries = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var initialPage = 1;
    var initialPageSize = 5000;
    var reportId = useParams().reportId;
    var reportDate = useParams().reportDate;
    var _a = useState({
        page: initialPage,
        pageSize: initialPageSize,
        reportTrigger: false,
        expoReportTrigger: false,
        exportExcelTrigger: false,
        reportName: "",
        bodyExeReport: {
            id: "",
            params: { from: "", to: "" },
            page: initialPage,
            pageSize: initialPageSize,
        },
        bodyReport: { page: 0, pageSize: 10 },
    }), state = _a[0], setState = _a[1];
    var _b = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), toast = _b[0], setToast = _b[1];
    var _c = useState([]), columns = _c[0], setColumns = _c[1];
    var _d = useState([]), rows = _d[0], setRows = _d[1];
    var _e = useApiPostExecuteReports(state.reportTrigger, state.bodyExeReport), loadingExecuteReports = _e.loadingExecuteReports, responseExecuteReports = _e.responseExecuteReports, errorExecuteReports = _e.errorExecuteReports;
    var _f = useApiPostReports(state.reportTrigger, state.bodyReport), loadingReports = _f.loadingReports, responseReports = _f.responseReports, errorReports = _f.errorReports;
    var _g = useDownloadReportExcel({
        trigger: state.exportExcelTrigger,
        reportBody: state.bodyExeReport,
        filename: state.reportName,
        onFinish: function () {
            return setState(function (prev) { return (__assign(__assign({}, prev), { exportExcelTrigger: false })); });
        },
    }), loading = _g.loading, error = _g.error;
    useEffect(function () {
        setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: true })); });
        onClickMonthReport(reportDate || "");
    }, []);
    useEffect(function () {
        if (errorExecuteReports) {
            showErrorToast(errorExecuteReports, setToast, t);
            setState(function (prev) { return (__assign(__assign({}, prev), { expoReportTrigger: false })); });
            dispatch(executeReportsClearData());
        }
    }, [errorExecuteReports]);
    useEffect(function () {
        if (errorReports) {
            showErrorToast(errorReports, setToast, t);
            setState(function (prev) { return (__assign(__assign({}, prev), { expoReportTrigger: false })); });
            dispatch(reportsClearData());
        }
    }, [errorReports]);
    useEffect(function () {
        if ((responseExecuteReports === null || responseExecuteReports === void 0 ? void 0 : responseExecuteReports.length) > 0) {
            var firstItem = responseExecuteReports[0];
            var columnOrder_1 = Object.getOwnPropertyNames(firstItem);
            var columns_1 = columnOrder_1.map(function (key) {
                var baseColumn = {
                    field: key,
                    headerName: key
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, function (str) { return str.toUpperCase(); }),
                    width: 200,
                };
                if (key.toLowerCase().includes("fecha")) {
                    return __assign(__assign({}, baseColumn), { valueFormatter: function (params) { return newFormattedDate(params.value); } });
                }
                return baseColumn;
            });
            var rows_1 = responseExecuteReports.map(function (item, index) {
                var rowWithDefaults = __assign({}, item);
                columnOrder_1.forEach(function (col) {
                    if (!(col in rowWithDefaults)) {
                        rowWithDefaults[col] = null;
                    }
                });
                if (rowWithDefaults["Prima"]) {
                    var primaNumber = parseFloat(rowWithDefaults["Prima"]);
                    if (!isNaN(primaNumber)) {
                        rowWithDefaults["Prima"] = "RD$ ".concat(primaNumber.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }));
                    }
                }
                return __assign({ id: item.Cotizacion || "row-".concat(index) }, rowWithDefaults);
            });
            setColumns(columns_1);
            setRows(rows_1);
        }
        dispatch(executeReportsClearData());
    }, [responseExecuteReports]);
    useEffect(function () {
        if ((responseReports === null || responseReports === void 0 ? void 0 : responseReports.length) > 0) {
            var reportFind_1 = responseReports.find(function (report) { return report.id === reportId; });
            setState(function (prev) { return (__assign(__assign({}, prev), { reportName: reportFind_1.name || "" })); });
            dispatch(reportsClearData());
        }
    }, [responseReports, reportId]);
    var onClickMonthReport = function (date) {
        var _a, _b, _c, _d, _e;
        var startDate = "";
        var endDate = "";
        switch (date) {
            case "currentMonth":
                (_a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate);
                break;
            case "prevMonth":
                (_b = getPreviousMonth(), startDate = _b.startDate, endDate = _b.endDate);
                break;
            case "currentQuarter":
                (_c = getPreviousMonth(), startDate = _c.startDate, endDate = _c.endDate);
                break;
            case "prevQuarter":
                (_d = getQuarterDates("previous"), startDate = _d.startDate, endDate = _d.endDate);
                break;
            case "currentSemester":
                (_e = getCurrentSemester(), startDate = _e.startDate, endDate = _e.endDate);
                break;
        }
        setState(function (prev) { return (__assign(__assign({}, prev), { bodyExeReport: __assign(__assign({}, prev.bodyExeReport), { id: reportId || "", params: {
                    from: startDate,
                    to: endDate,
                } }), expoReportTrigger: true })); });
    };
    var onBack = function () {
        navigate("/report-quote-sales");
    };
    var onChangeFilters = function (data) {
        if (data && Object.keys(data).length > 0) {
            var getFormattedDate = function (index) {
                var _a;
                var isValidDateRange = Array.isArray(data === null || data === void 0 ? void 0 : data.dateRange) && data.dateRange.length > 0;
                if (!isValidDateRange)
                    return "";
                var formattedDate = formattedDateYYMMDD((_a = data === null || data === void 0 ? void 0 : data.dateRange) === null || _a === void 0 ? void 0 : _a[index]);
                return formattedDate === "undefined" ||
                    formattedDate === "null" ||
                    formattedDate === "NA"
                    ? ""
                    : formattedDate;
            };
            var startDate_1 = getFormattedDate(0);
            var endDate_1 = getFormattedDate(1);
            setState(function (prev) { return (__assign(__assign({}, prev), { bodyExeReport: __assign(__assign({}, prev.bodyExeReport), { id: reportId || "", params: {
                        from: startDate_1,
                        to: endDate_1,
                    } }), expoReportTrigger: true })); });
        }
    };
    var onExportReport = function (i) {
        switch (i.id) {
            case "1":
                setState(function (prev) { return (__assign(__assign({}, prev), { exportExcelTrigger: true })); });
        }
    };
    var onClearFilter = function () {
        onClickMonthReport(reportDate || "");
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingExecuteReports || loadingReports || loading, seeToast: toast, showToast: showToast, setSeeToast: setToast, titleLoading: "Cargando Reporte" }), _jsx(ReportsSumariesView, { columns: columns, rows: rows, onBack: onBack, reportName: state.reportName, onChangeFilter: onChangeFilters, onClearFilter: onClearFilter, onExportReport: onExportReport })] }));
};
